import styled from 'styled-components';

export const SectionWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;

    padding: 1rem;
`;